import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useGroomerListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const [groomerList,setGroomerList]=useState<any>(null)

  const execute = useCallback(async (booking_id:string) => {
    
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(`${PATIENT_WAITING_LIST?.CLINIC_GROOMERS_LIST?.baseURL}?booking_id=${booking_id}` , {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<any>) => {
          if (res.data.status === true) {
            setGroomerList(res.data.data)
            
          } else {
            setGroomerList(null)
          }
        })
        .catch((e: AxiosError) => {
          setGroomerList(null)
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching user role.");
          }
          if (e.status === 400) {
            toast.error(e.message);
          }
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return {execute,groomerList};
};
